<template>
  <layout-vertical>

    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

  </layout-vertical>
</template>

<script>
import LayoutVertical from './LayoutContent.vue'

const Navbar = () => import(`@/layouts/${process.env.VUE_APP_THEME_NAME}/components/Navbar.vue`)

export default {
  components: {
    LayoutVertical,
    Navbar,
  },
  data() {
    return {
    }
  },
}
</script>
